import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';

export function SignInIsolvedCredential({
  isLoading,
  onSubmit,
  provider,
}: RegisterImplementationProps) {
  return (
    <SignInBase
      formLabel={`${provider.displayName} Sign In Form`}
      onSubmit={onSubmit}
      fieldNames={['username', 'password']}
      render={({ username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Username"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://identity.myisolved.com/'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !username.value || !password.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
}
